import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@mui/styles';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import download from '../images/download-doc.svg';
import downloadpdf from '../images/download-pdf.png';
import 'react-daterange-picker/dist/css/react-calendar.css';
import Divider from '@mui/material/Divider';
import spinner from '../../assign-prescriptions/images/spinner.gif';
import PatientManulOverride from '../../common/patient_manual_override';
import {Box, Grid, IconButton} from '@mui/material';
import PrintTemplate from 'react-print';
import moment from 'moment-timezone';
import {withTranslation} from 'react-i18next';
import ILocalAGGrid, {
  getDefaultColDef,
  createServerSideDatasource,
  withDateColumnFilter,
  applyReportFilterModel,
  attachReportServerSideDatasource,
  withClickableCell,
  resolveGridRow,
} from "../../grid/iLocalAGGrid";
import getTypeByLang from '../../common/typeByLang';
import checked from '../images/checked.png';
import Checkbox from '@mui/material/Checkbox';
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import {getDefaultDateRange, getDateRangeByPreset, formatFromDateForAPI, formatToDateForAPI} from "../../../utils/datetime.utils";


class EnhancedTableHead extends React.Component {
  createSortHandler = (property, field) => (event) => {
    this.props.onRequestSort(event, property, field);
  };

  render() {
    const {order, orderBy, sortId, t} = this.props;
    const rows = [
      {
        id: 'store',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.Store'),
        padding: '8px',
        field: 'name',
      },
      {
        id: 'box',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.Location'),
        padding: '8px',
        field: 'name',
      },
      {
        id: 'deliverytype',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.DeliverType'),
        padding: '8px',
        field: 'name',
      },
      {
        id: 'binid',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.BIN'),
        padding: '8px',
        field: 'bin_id',
      },
      {
        id: 'rxno',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.RxHash'),
        padding: '8px',
        field: 'rx_no',
      },
      {
        id: 'fillid',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.FillID'),
        padding: '8px',
        field: 'fill_id',
      },
      {
        id: 'patientNotes',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.PatientNotes'),
        padding: '8px',
        field: 'notes',
      },
      {
        id: 'prescriptionnumber',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.PrescriptionNumber'),
        padding: '8px',
        field: 'prescriptionnumber',
      },
      {
        id: 'OrderId',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.OrderID'),
        padding: '8px',
        field: 'order_id',
      },
      {
        id: 'PrescriptionTxnId',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.TransactionID'),
        padding: '8px',
        field: 'prescription_txn_id',
      },
      {
        id: 'filldate',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.FillDate'),
        padding: '8px',
        field: 'fill_date',
      },
      {
        id: 'stockeddate',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.StockCode'),
        padding: '8px',
        field: 'stocked_date',
      },
      {
        id: 'stock_code',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.StockDate'),
        padding: '8px',
        field: 'stock_code',
      },
      {
        id: 'pucode',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.PUCode'),
        padding: '8px',
        field: 'pucode',
      },
      {
        id: 'firstname',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.FirstName'),
        padding: '8px',
        field: 'first_name',
      },
      {
        id: 'lastname',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.LastName'),
        padding: '8px',
        field: 'last_name',
      },
      {
        id: 'ndccode',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.NDCCode'),
        padding: '8px',
        field: 'ndc_code',
      },
      {
        id: 'drugname',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.DrugName'),
        padding: '8px',
        field: 'drug_name',
      },
      {
        id: 'qty',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.Qty'),
        padding: '8px',
        field: 'qty',
      },
      {
        id: 'price',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.AmountDue'),
        padding: '8px',
        field: 'price',
      },
      {
        id: 'is_consultrequire',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.ConsultRequired'),
        padding: '10px',
        field: 'is_consultrequire',
      },
      {
        id: 'username',
        numeric: false,
        disablePadding: false,
        label: t('Report.Stocked.User'),
        padding: '8px',
        field: 'username',
      },
    ];

    return (
      <TableHead>
        <TableRow>
          {rows.map((row) => {
            return (
              <TableCell
                key={row.id}
                align={row.numeric ? 'right' : 'left'}
                padding={row.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === row.id ? order : false}
                style={{ padding: row.padding, color: 'grey' }}
              >
                {[
                  'deliverytype',
                  'fillid',
                  'prescriptionnumber',
                  'OrderId',
                  'PrescriptionTxnId',
                  'filldate',
                  'ndccode',
                  'qty',
                  'price',
                ].includes(row.id) ? (
                  <TableSortLabel style={{ cursor: 'text' }}>
                    {row.label}
                  </TableSortLabel>
                ) : (
                  <Tooltip
                    title={t('Global.Label.Filter.Sort')}
                    placement={row.numeric ? 'bottom-end' : 'bottom-start'}
                    enterDelay={300}
                  >
                    <TableSortLabel
                      active={orderBy === row.field && sortId === row.id}
                      direction={order}
                      onClick={this.createSortHandler(row.id, row.field)}
                    >
                      {row.label}
                    </TableSortLabel>
                  </Tooltip>
                )}
              </TableCell>
            );
          }, this)}
        </TableRow>
      </TableHead>
    );
  }
}

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  sortId: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

const styles = (theme) => ({
  root: {
    width: '100%',
    // marginTop: theme.spacing.unit * 3
  },
  table: {
    minWidth: 1020,
  },
  tableWrapper: {
    overflowX: 'auto',
    // paddingTop:'10%'
  },
  dob: {
    paddingTop: '25px',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10',
  },
  padding10px: {
    padding: '10px',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    maxWidth: 390,
  },
  logoWrapper: {
    position: 'absolute',
    width: '89%',
    height: '70%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(255,255,255,0.5)',
    zIndex: '7869',
  },
  spinner: {
    position: 'absolute',
    background: 'rgba(255,255,255,.4)',
    width: '100%',
    height: '100%',
    zIndex: '9999',
    top: 0,
    left: 0,
  },
  spinnerImage: {
    top: 'calc(50% - 32.5px)',
    left: 'calc(50% - 65px)',
    position: 'absolute',
    width: '130px',
    userSelect: 'none',
  },
  hidden: {
    display: 'none',
  },
});

const __reportDefaultDates = getDefaultDateRange();

let TransactionFilterObj = {
  store_ids: [],
  box_ids: [],
  searchtext: '',
  fromdate: formatFromDateForAPI(__reportDefaultDates.fromDate),
  todate: formatToDateForAPI(__reportDefaultDates.toDate),
  pageNo: 0,
  pageSize: 10,
  sortOrder: 'desc',
  sortColumn: 'stocked_date',
  tableName: '',
  group_id: null
};

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment()
  .tz(timeZone)
  .utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class EnhancedTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      order: 'desc',
      dob: '',
      orderBy: 'created_on',
      page: 0,
      rowsPerPage: 10,
      searchtext: '',
      store_ids: [],
      box_ids: [],
      fromdate: null,
      todate: null,
      dateRangePreset: 'last7days',
      isOpen: false,
      stores: [],
      boxes: [],
      boxvalues: [],
      accountValues: [],
      nstores: [],
      nboxes: [],
      chipstores: [],
      chipboxes: [],
      loader: false,
      isDataEmpty: true,
      selectedObject: null,
      isUserValidate: false,
      stockPrint: [],
      totalRecords: 0,
      htmlBodyToPrint: '',
      isButtonDisabled: false,
      locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale,
      queryId: "",
      groups: [],
      openPrintDialog: false,
      sortId: 'stockeddate'
    };
    this.handleStoreChange = this.handleStoreChange.bind(this);
    this.handleBoxChange = this.handleBoxChange.bind(this);
    this.debouceTimeout = null;
  }

  refreshGrid = () => {
    if (!this.gridApi) return;
    if (typeof this.gridApi.refreshServerSideStore === "function") {
      this.gridApi.refreshServerSideStore({ purge: true });
    } else if (typeof this.gridApi.refreshServerSide === "function") {
      this.gridApi.refreshServerSide({ purge: true });
    }
  };

  onPaginationChanged = (params) => {
    if (!params.api) return;
    const newPageSize = params.api.paginationGetPageSize();
    if (newPageSize && TransactionFilterObj.pageSize !== newPageSize) {
      TransactionFilterObj.pageSize = newPageSize;
    }
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    const datasource = createServerSideDatasource({
      filterBody: TransactionFilterObj,
      applyFilterModel: (body, filterModel) => {
        applyReportFilterModel(body, filterModel, { dateColIds: ['stockeddate'] });
      },
      pageZeroBased: true,
      getPageSize: () => TransactionFilterObj.pageSize || 10,
      fetchPage: (body) =>
        fetch(process.env.REACT_APP_BASEURL + "getStocklist", {
          method: "post",
          withCredentials: true,
          headers: {
            Authorization:
              "Bearer " +
              JSON.parse(sessionStorage.getItem("user")).signInUserSession
                .idToken.jwtToken,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        })
          .then((r) => r.json())
          .then((data) => {
            if (data && data.results) return data;
            if (data && data.data && data.data.results) {
              return { results: data.data.results, total: data.data.total };
            }
            if (Array.isArray(data)) return { results: data, total: data.length };
            return {
              results: (data && (data.rows || data.data)) || [],
              total: (data && data.total) || 0,
            };
          }),
      onSuccess: (results, total) => {
        this.setState({
          data: results,
          totalRecords: total,
          loader: false,
          isDataEmpty: !results || results.length === 0,
        });
      },
      onError: () => this.setState({ loader: false }),
    });
    attachReportServerSideDatasource(params, datasource, TransactionFilterObj, 'stockeddate');
  };

  componentDidMount() {
    TransactionFilterObj.group_id = sessionStorage.getItem("groupID")
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'accounts', {
      method: 'GET',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((accounts) => {
        const {t} = this.props;
        let All = [{ id: '-1', name: t('Global.Label.DropDown.All') }];
        const storelist = accounts.map((account) => {
          return { id: account.id, name: account.name };
        });

        const accountValues = All.concat(storelist);
        this.setState({
          accountValues,
          parent_account_id: accountValues[0].id,
        });
        this.BindBoxesbyStoreId(storelist.map((x) => x.id));
        this.setState({ loader: false });
      });
    // Set default date range (T-30 days to today)
    const defaultDates = getDefaultDateRange();
    this.setState({ 
      fromdate: defaultDates.fromDate,
      todate: defaultDates.toDate,
      dateRangePreset: 'last7days'
    });

    Object.assign(TransactionFilterObj, {
      store_ids: [],
      box_ids: [],
      searchtext: '',
      fromdate: formatFromDateForAPI(defaultDates.fromDate),
      todate: formatToDateForAPI(defaultDates.toDate),
      pageNo: 0,
      pageSize: 10,
      sortOrder: 'desc',
      sortColumn: 'stocked_date',
      tableName: ''});
    this.fetchSuggestions()
    this.setState({ loader: false });
  }

  convertToTimeZone = (requestDate) => {
    const currentUserLang = localStorage.getItem('i18nextLng');
    let zone;
    zone = sessionStorage.getItem('timeZone');
    const date = moment(new Date(requestDate));
    if (['null', null, 'undefined', undefined].includes(zone)) {
      zone = defaultZone;
    }
    return currentUserLang === 'en'
      ? date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('MM/DD/YYYY hh:mm:ss A')
      : date
        .tz(zone.substring(zone.lastIndexOf(' ') + 1))
        .format('DD/MM/YYYY hh:mm:ss A');
  };

  // Helper function to properly escape CSV field values
  escapeCsvField(field) {
    if (field === null || field === undefined) {
      return '';
    }
    
    // Convert to string
    const value = String(field);
    
    // Check if field needs to be quoted (contains comma, quote, newline, or carriage return)
    const needsQuoting = /[",\n\r]/.test(value);
    
    if (needsQuoting) {
      // Escape quotes by doubling them and wrap in quotes
      return '"' + value.replace(/"/g, '""') + '"';
    }
    
    return value;
  }

  exportCSV() {
    this.setState({ loader: true });
    fetch(process.env.REACT_APP_BASEURL + 'CSV/StockedItemsReport', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(TransactionFilterObj),
    })
      .then((response) => {
        try {
          return response.json();
        } catch (error) {
          return null;
        }
      })
      .then((csvData) => {
        this.setState({ loader: false });
        let csvRows = [];
        
        // Add header row
        const headers = [
          'Store',
          'Box',
          'BIN',
          'Rx No',
          'Fill ID',
          'Patient Notes',
          'Prescription Number',
          'Fill Date',
          'Stock Date',
          'StockCode',
          'PickUpCode',
          'FirstName',
          'LastName',
          'NDC Code',
          'Drug Name',
          'Qty',
          'Amount Due',
          'Consultation',
          'User',
        ];
        csvRows.push(headers.map(h => this.escapeCsvField(h)).join(','));
        
        let result =
          csvData && csvData.Results && csvData.Results.length > 0
            ? csvData.Results
            : [];
        
        if (result !== undefined && result !== 'undefined') {
          if (result && result.length > 0) {
            for (let i of result) {
              const row = [
                this.escapeCsvField(i.store),
                this.escapeCsvField(i.box),
                this.escapeCsvField(i.binid),
                this.escapeCsvField(i.rxno),
                this.escapeCsvField(i.fillid),
                this.escapeCsvField(i.patientNotes),
                this.escapeCsvField(i.prescriptionnumber),
                this.escapeCsvField(i.filldate ? this.convertToTimeZone(i && i.filldate) : ''),
                this.escapeCsvField(i.stockeddate ? this.convertToTimeZone(i && i.stockeddate) : ''),
                this.escapeCsvField(i.stock_code),
                this.escapeCsvField(i.pucode),
                this.escapeCsvField(i.firstname),
                this.escapeCsvField(i.lastname),
                this.escapeCsvField(i.ndccode),
                this.escapeCsvField(i.drugname),
                this.escapeCsvField(i.qty),
                this.escapeCsvField(i.price ? '$' + parseFloat(i.price).toFixed(2) : '$0.00'),
                this.escapeCsvField(i.is_order_released
                  ? 'Completed'
                  : i.is_consultrequire
                    ? 'Yes'
                    : 'No'),
                this.escapeCsvField(i.username),
              ];
              csvRows.push(row.join(','));
            }

            // Use proper newlines for CSV format
            let csvString = csvRows.join('\n');
            
            // Create blob for proper CSV download
            const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            
            link.setAttribute('href', url);
            link.setAttribute('download', 'StockedItemsReport.csv');
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            // Clean up the URL object
            URL.revokeObjectURL(url);
          }
        }
      });
  }

  //TODO: removed print stock report functionality for now because of deployment large build size issue.
  printStockDetails = () => {
    this.setState({ loader: true });
    const stockObj = {
      store_ids: this.state.store_ids,
      box_ids: this.state.box_ids,
      searchtext: this.state.searchtext,
      fromdate: this.state.fromdate,
      todate: this.state.todate,
    };
    fetch(process.env.REACT_APP_BASEURL + 'PrintStocklist', {
      method: 'post',
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(stockObj),
    })
      .then((response) => {
        try {
          return response.text();
        } catch (error) {
          return null;
        }
      })
      .then((data) => {
        this.setState({ loader: false });
        this.setState({ stockPrint: data });
        let print = this.state && this.state.stockPrint.split('"');
        let printPdf = print[3];
        window.open(printPdf);
        // let a=document.getElementById("stockPrint");
        // a.innerHTML = data;
        // let win =  window.open('','list','');
        // win.document.write(data);
        // win.print();
        // win.close();
      });
  };

  gettingOnSortTableName = (field) => {
    let tablename = '';
    if (['firstname', 'lastname', 'patientNotes'].includes(field)) {
      tablename = 'customers';
    }
    if (['box'].includes(field)) {
      tablename = 'boxes';
    }
    if (['rxno', 'drugname', 'is_consultrequire'].includes(field)) {
      tablename = 'prescription_detail';
    }
    if (['stock_code', 'pucode', 'stockeddate', 'binid'].includes(field)) {
      tablename = 'prescriptions_master';
    }
    if (['username'].includes(field)) {
      tablename = 'users';
    }
    if (['store'].includes(field)) {
      tablename = 'accounts';
    }
    return tablename;
  };

  handleRequestSort = (event, property, field) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === orderBy) {
      order = this.state.order === 'asc' ? 'desc' : 'asc';
    } else if (this.state.order === order) {
      order = 'asc';
    } else {
      order = 'desc';
    }
    this.setState({ order, orderBy, sortId: property });
    TransactionFilterObj.sortOrder = order;
    TransactionFilterObj.sortColumn = field;
    TransactionFilterObj.tableName = this.gettingOnSortTableName(orderBy);
    
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangePage = (event, page) => {
    
    TransactionFilterObj.pageNo = page;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  handleChangeRowsPerPage = (event) => {
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.pageSize = event.target.value;
    if (this.state.data && this.state.data.length > 0) {
      this.BindGrid();
    }
  };

  //Bind Boxes by store id
  BindBoxesbyStoreId(store_ids) {
    if (store_ids.length > 0) {
      this.setState({ loader: true });
      let BoxesObj = {
        store_ids: store_ids,
      };
      fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
        method: 'post',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(BoxesObj),
      })
        .then((response) => {
          try {
            return response.json();
          } catch (error) {
            return null;
          }
        })
        .then((data) => {
          const {t} = this.props;
          let All = [{ id: '-1', name: t('Global.Label.DropDown.All') }];
          const boxlist = data.map((account) => {
            return { id: account.id, name: account.name };
          });
          const boxvalues = All.concat(boxlist);
          this.setState({ chipboxes: [] });
          this.setState({ nboxes: [] });
          this.setState({ boxvalues: boxvalues });
          this.setState({ loader: false });
        });
    }
  }
  handleStoreChange = (event) => {
    const storeid = event.target.value;
    const storeids = [];
    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = storeid.findIndex((x) => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.accountValues[0]];
      for (let i = 0; i < this.state.accountValues.length; i++) {
        processed.push(this.state.accountValues[i]);
      }
    } else if (storeid.length === 0) {
      chipprocessed = [];
      processed = [];
    } else if (storeid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipstores: chipprocessed });
    this.setState({ nstores: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          storeids.push(processed[i].id);
        }
      }
    }
    this.setState({ store_id: storeids });
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    this.BindBoxesbyStoreId(storeids);
    this.BindGrid();
  };
  handleBoxChange = (event) => {
    const boxid = event.target.value;
    const boxids = [];

    let processed = [];
    let chipprocessed = [];
    const AllprocessedIndex = boxid.findIndex((x) => x.id === '-1');
    
    if (AllprocessedIndex > -1) {
      chipprocessed = [this.state.boxvalues[0]];
      for (let i = 0; i < this.state.boxvalues.length; i++) {
        processed.push(this.state.boxvalues[i]);
      }
    } else if (boxid.length === 0) {
      chipprocessed = [];
      processed = [];
    } else if (boxid.length > 0) {
      for (let i = 0; i < event.target.value.length; i++) {
        const element = event.target.value[i];
        if (element.id !== '-1') {
          chipprocessed.push(element);
          processed.push(element);
        }
      }
    }
    
    this.setState({ chipboxes: chipprocessed });
    this.setState({ nboxes: processed });

    if (processed.length > 0) {
      for (let i = 0; i < processed.length; i++) {
        if (processed[i].id !== '-1') {
          boxids.push(processed[i].id);
        }
      }
    }
    this.setState({ box_id: boxids });
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    this.BindGrid();
  };

  handleDeleteStoreChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipstores: [], nstores: [], store_id: [] });
      TransactionFilterObj.store_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindBoxesbyStoreId([]);
      this.BindGrid();
      return;
    }
    const updatedStores = this.state.chipstores.filter(chip => chip.id !== chipToDelete.id);
    const updatedNStores = this.state.nstores.filter(store => store.id !== chipToDelete.id);
    this.setState({ chipstores: updatedStores, nstores: updatedNStores });
    const storeids = updatedNStores.filter(s => s.id !== '-1').map(s => s.id);
    this.BindBoxesbyStoreId(storeids);
    TransactionFilterObj.store_ids = storeids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleDeleteBoxChip = (chipToDelete) => (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    if (chipToDelete.id === '-1') {
      this.setState({ chipboxes: [], nboxes: [], box_id: [] });
      TransactionFilterObj.box_ids = [];
      TransactionFilterObj.pageNo = 0;
      this.BindGrid();
      return;
    }
    const updatedBoxes = this.state.chipboxes.filter(chip => chip.id !== chipToDelete.id);
    const updatedNBoxes = this.state.nboxes.filter(box => box.id !== chipToDelete.id);
    this.setState({ chipboxes: updatedBoxes, nboxes: updatedNBoxes });
    const boxids = updatedNBoxes.filter(b => b.id !== '-1').map(b => b.id);
    TransactionFilterObj.box_ids = boxids;
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  handleClearAllStores = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipstores: [], nstores: [], store_id: [] });
    TransactionFilterObj.store_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindBoxesbyStoreId([]);
    this.BindGrid();
  };

  handleClearAllBoxes = (event) => {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.setState({ chipboxes: [], nboxes: [], box_id: [] });
    TransactionFilterObj.box_ids = [];
    TransactionFilterObj.pageNo = 0;
    this.BindGrid();
  };

  //Search Text Box change event
  onSearchChange = (event) => {
    this.debouceTimeout && clearInterval(this.debouceTimeout);
    const searchString = event.target.value;
    this.setState({ searchtext: searchString && searchString });
    TransactionFilterObj.searchtext = searchString;
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    this.debouceTimeout = setTimeout(() => {
      this.BindGrid();
    }, 1000)
  };
  onFromDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ fromdate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
  };
  onToDateSelect = (date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({ todate: dateObj, dateRangePreset: '' });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
  };

  handleBlurfrom = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      fromdate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: false });
  };
  handleBlurtodate = (value, date) => {
    const dateObj = date ? moment(date) : null;
    this.setState({
      todate: dateObj,
      dateRangePreset: ''
    });
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.todate = formatToDateForAPI(dateObj);
    this.BindGrid();
    this.setState({ loader: false });
  };
  
  handleDateRangePresetChange = (event) => {
    const preset = event.target.value;
    if (!preset) return;
    
    const dateRange = getDateRangeByPreset(preset);
    this.setState({
      fromdate: dateRange.fromDate,
      todate: dateRange.toDate,
      dateRangePreset: preset
    });
    
    TransactionFilterObj.pageNo = 0;
    TransactionFilterObj.sortOrder = 'desc';
    TransactionFilterObj.sortColumn = 'stocked_date';
    TransactionFilterObj.tableName = '';
    TransactionFilterObj.fromdate = formatFromDateForAPI(dateRange.fromDate);
    TransactionFilterObj.todate = formatToDateForAPI(dateRange.toDate);
    this.BindGrid();
  };

  BindGrid = () => {
    if (this.gridApi) {
      this.refreshGrid();
      return;
    }
    // SSRM datasource is attached in onGridReady; avoid a parallel
    // legacy fetch/setState race that leaves the grid on Please Wait...
    this.setState({ loader: false });
  };
  handlePUcodeClick = (event, pmid) => {
    if (event && typeof event.preventDefault === 'function') event.preventDefault();
    const selectedObject = resolveGridRow(pmid, this.state.data, (x, id) => x.pmid === id);
    if (!selectedObject) return;
    this.setState({
      detailDialogOpen: true,
      selectedObject: selectedObject,
      isUserValidate: false,
    });
  };

  handlePUcodeClose = () => {
    this.setState({
      detailDialogOpen: false,
      selectedObject: null,
      isUserValidate: false,
    });
  };

  exportPDF = () => {
    try {
      this.setState({ loader: true });
      fetch(process.env.REACT_APP_BASEURL + 'printDeliveryManifestStockItems', {
        method: 'post',
        withCredentials: true,
        headers: {
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(TransactionFilterObj),
      })
        .then((response) => {
          try {
            return response.text();
          } catch (error) {
            return null;
          }
        })
        .then((res) => {
          this.setState({ loader: false });
          var x = window.open(
            '',
            'title',
            'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=1000,height=1000,left=145,top=100'
          );
          x.document.write(res);
          x.document.close();
          setTimeout(() => {
            x.print();
            x.close();
          }, 1300);
        })
        .catch((error) => {
          this.setState({ loader: false });
        });
    } catch (error) {
      this.setState({ loader: false });
    }
  };

  setHtmlForPrint = (data) => this.setState({ htmlBodyToPrint: data });

  handleInputChange = (event) => {
    this.setState({ queryId: event.target.value });
    TransactionFilterObj.group_id = event.target.value
    this.BindGrid();
  };

  fetchSuggestions = async () => {
    try {
      const result = fetch(`${process.env.REACT_APP_BASEURL}groups/search`, {
        method: "GET",
        withCredentials: true,
        headers: {
          Authorization:
            "Bearer " +
            JSON.parse(sessionStorage.getItem("user")).signInUserSession.idToken
              .jwtToken,
          "Content-Type": "application/json",
        },
      }
      );
      result
        .then((result) => {
          result.json().then((resLocation) => {
            this.setState({ groups: resLocation && resLocation.data })
          })
        })
    } catch (error) {
      console.error("Error fetching groups:", error);
    }
  };

  openPrintDialog = () => {
    this.setState({ openPrintDialog: true });
  }

  closePrintDialog = () => {
    this.setState({ openPrintDialog: false });
  }

  render() {
    const {classes, t} = this.props;
    const {htmlBodyToPrint} = this.state;
    const permissions = JSON.parse(sessionStorage.getItem('permissions'));
    let isManualOverridePermissionEnabled
    if (permissions && permissions.length > 0) {
      isManualOverridePermissionEnabled = permissions.some((item) => item.name === 'Open Bin' && item.is_allowed === 1);
    } else {
      isManualOverridePermissionEnabled = false;
    }
    return (
      <div>
        {this.state.loader ? (
          <div className={classes.spinner}>
            <img className={classes.spinnerImage} src={spinner} alt='loading' />
          </div>
        ) : null}
        <div>
          {this.state.detailDialogOpen ? (
            <PatientManulOverride
              detailDialogOpen={this.state.detailDialogOpen}
              selectedObject={this.state.selectedObject}
              isUserValidate={this.state.isUserValidate}
              onPopupClose={this.handlePUcodeClose}
              setHtmlForPrint={this.setHtmlForPrint}
              isPatientDetailsVisible={true}
              isBoxDetailsVisible={true}
              isManualOverrideVisible={isManualOverridePermissionEnabled}
              isManualConsultVisible={true}
              openPrintDialog={this.openPrintDialog}
              closePrintDialog= {this.closePrintDialog}
            />
          ) : null}
          <Box component='div'>
            <Grid container direction={'row'} alignItems={'center'} justifyContent={'flex-end'} spacing={2} sx={{ mt: 0, ml: 0, width: '100%', p: '0% 2% 1%' }}>
              <Grid item xs={12} md={12} sx={{ textAlign: 'end' }}>
                <Tooltip
                  key='export-csv'
                  title={t('Report.Stocked.ExportCSVtooltip')}
                >
                  <IconButton
                    style={{ marginRight: '0' }}
                    aria-label='ExportCSV'
                    onClick={() => {
                      this.exportCSV();
                    }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img
                      alt='download'
                      src={download}
                      style={{
                        height: '32px',
                        width: '32px',
                        cursor: 'pointer',
                      }}
                    />
                  </IconButton>
                </Tooltip>
                <Tooltip
                  key='export-pdf'
                  title={t('Report.Stocked.ExportPDFTooltip')}
                >
                  <IconButton
                    aria-label='ExportPDF'
                    onClick={() => {
                      this.exportPDF();
                    }}
                    disabled={this.state.isButtonDisabled}
                  >
                    <img
                      alt='download'
                      src={downloadpdf}
                      style={{
                        height: '32px',
                        width: '32px',
                        cursor: 'pointer',
                      }}
                    />
                  </IconButton>
                </Tooltip>
              </Grid>
            </Grid>
          </Box>
        </div>
        <Divider style={{ marginTop: '10px', height: '5px' }} />
        <div className={classes.tableWrapper}>
          <ILocalAGGrid
            columnDefs={[
              { field: 'store', headerName: t('Report.Stocked.Store'), colId: 'store' },
              { field: 'box', headerName: t('Report.Stocked.Location'), colId: 'box' },
              { field: 'deliverytype', headerName: t('Report.Stocked.DeliverType'), colId: 'deliverytype', valueFormatter: (p) => getTypeByLang(p.value, t) },
              { field: 'binid', headerName: t('Report.Stocked.BIN'), colId: 'binid' },
              { field: 'rxno', headerName: t('Report.Stocked.RxHash'), colId: 'rxno' },
              { field: 'fillid', headerName: t('Report.Stocked.FillID'), colId: 'fillid' },
              { field: 'patientNotes', headerName: t('Report.Stocked.PatientNotes'), colId: 'patientNotes', valueFormatter: (p) => !['', null, 'null'].includes(p.value) ? p.value : '' },
              { field: 'prescriptionnumber', headerName: t('Report.Stocked.PrescriptionNumber'), colId: 'prescriptionnumber' },
              { field: 'order_id', headerName: t('Report.Stocked.OrderID'), colId: 'OrderId' },
              { field: 'prescription_txn_id', headerName: t('Report.Stocked.TransactionID'), colId: 'PrescriptionTxnId' },
              { field: 'filldate', headerName: t('Report.Stocked.FillDate'), colId: 'filldate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' },
              { field: 'stock_code', headerName: t('Report.Stocked.StockCode'), colId: 'stock_code' },
              withDateColumnFilter({ field: 'stockeddate', headerName: t('Report.Stocked.StockDate'), colId: 'stockeddate', valueFormatter: (p) => p.value ? this.convertToTimeZone(p.value) : '' }),
              withClickableCell(
                { field: 'pucode', headerName: t('Report.Stocked.PUCode'), colId: 'pucode' },
                (e, row) => this.handlePUcodeClick(e, row)
              ),
              { field: 'firstname', headerName: t('Report.Stocked.FirstName'), colId: 'firstname' },
              { field: 'lastname', headerName: t('Report.Stocked.LastName'), colId: 'lastname' },
              { field: 'ndccode', headerName: t('Report.Stocked.NDCCode'), colId: 'ndccode' },
              { field: 'drugname', headerName: t('Report.Stocked.DrugName'), colId: 'drugname' },
              { field: 'qty', headerName: t('Report.Stocked.Qty'), colId: 'qty' },
              { field: 'price', headerName: t('Report.Stocked.AmountDue'), colId: 'price', valueFormatter: (p) => p.value ? '$' + parseFloat(p.value).toFixed(2) : '$0.00' },
              {
                field: 'is_consultrequire',
                headerName: t('Report.Stocked.ConsultRequired'),
                colId: 'is_consultrequire',
                minWidth: 140,
                cellRenderer: (p) => {
                  if (p.data && p.data.is_order_released === true) {
                    return <img src={checked} alt={p.data.is_order_released} height={24} width={24} />;
                  }
                  return (
                    <Checkbox
                      checked={!!(p.data && p.data.is_consultrequire)}
                      disabled={true}
                      value={p.data && p.data.is_consultrequire}
                      sx={{ width: '24px', '&.Mui-disabled': { color: '#00a7e1' } }}
                    />
                  );
                },
              },
              { field: 'username', headerName: t('Report.Stocked.User'), colId: 'username' },
            ]}
            defaultColDef={getDefaultColDef()}
            rowModelType="serverSide"
            cacheBlockSize={TransactionFilterObj.pageSize || 10}
            paginationPageSize={TransactionFilterObj.pageSize || 10}
            paginationPageSizeSelector={[10, 20, 25]}
            rowHeight={40}
            getRowId={(params) =>
              (params.data && (params.data.prescription_txn_id || params.data.id || params.data.pmid || params.data.uuid)) ||
              String(params.data && JSON.stringify(params.data).slice(0,40))
            }
            onGridReady={this.onGridReady}
            onPaginationChanged={this.onPaginationChanged}
          />
        </div>
        <div id='print-mount'>
           <PrintTemplate>
             <Dialog
               open={this.state.openPrintDialog}
               PaperProps={{
                 sx: { borderRadius: '0px', minWidth: '700px', minHeight: '500px' },
               }}
             >
               <DialogContent sx={{ p: '10px' }}>
                 <div
                   dangerouslySetInnerHTML={{ __html: htmlBodyToPrint }}
                 ></div>
               </DialogContent>
             </Dialog>
           </PrintTemplate>
        </div>
      </div>
    );
  }
}

EnhancedTable.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(
  withTranslation()(EnhancedTable)
);



// WEBPACK FOOTER //
// ./src/components/reports/stock-list/index.js